export default __webpack_public_path__ + "static/media/PT3.355cdb59.webp";